// Brand assets — official Susegado Strike logos
export const LOGO_EMBLEM =
  "https://customer-assets.emergentagent.com/job_susegado-strike/artifacts/bfteb1c1_SS%20Logo-05.webp";
export const LOGO_WORDMARK =
  "https://customer-assets.emergentagent.com/job_susegado-strike/artifacts/mcl82zzk_SS%20Logo-01.webp";
